import { render, staticRenderFns } from "./TextColorProperties.vue?vue&type=template&id=11315036&scoped=true"
import script from "./TextColorProperties.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextColorProperties.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TextColorProperties.vue?vue&type=style&index=0&id=11315036&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11315036",
  null
  
)

export default component.exports